import { Component, OnInit, ChangeDetectorRef, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
// import { Ng2ImgMaxService } from 'ng2-img-max';
import { NgxImageCompressService } from 'ngx-image-compress';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { CommonHelper } from '../../../utilities/common.helper';
import { UploadDocumentsService } from './upload-document.service';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { LoaderService } from '../../sharedServices/loader.service';
import { decrypt } from '../../../utilities/utilityFunctions';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'kt-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {
  public isCollapsed = true;
  public formViewType:any;
  @ViewChild('uploadDocumentsDetail',{static:false}) uploadDocumentsDetail: NgForm;
  @Input('dropdownValues')dropdownValues:any= {};
  @Input('applicationId')applicationId:number;
  @Input('documentCategory')documentCategory:any;
  @Input('profileId')profileId:any;
  public degreeDetailsDocumentList:any;
  @ViewChild('fileDropRef',{static:false}) fileDropRef: ElementRef;
  files: any[] = [];
  public eduDropdownLevel:any={qualificationLevel:[],programTitle:[]};
  private selectedFilePayload: any;
  private attachmentBase64: string;
  public isImageAlert:boolean = false;
  private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.fileExt;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  public loader: boolean = false;
  public fileUploader:boolean=false;
  p
  @Output() uploadUpdatedData = new EventEmitter();
  constructor(private cdr: ChangeDetectorRef,
    // private ng2ImgMax: Ng2ImgMaxService,
    private imageCompress: NgxImageCompressService,
    public _snackBar: MatSnackBar,private loaderService:LoaderService,
    private sharedService:SharedService, private uploadService:UploadDocumentsService) { }

  ngOnInit() {
    this.degreeDetailsDocumentList = JSON.parse(decrypt(localStorage.getItem('degreeDetails')))
    }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
            this.fileUploader=false;
            this.cdr.detectChanges();
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(e: Array<any>) {
    if (e.length > 1) {
      return false;
    }
    let image = e[0];
    let test: File;
    let file = e[0];
    if (this.isValidFile(file)) {
      this.fileUploader = true;
      this.cdr.detectChanges();
      if (file.type !== 'application/pdf') {
        // this.ng2ImgMax.compressImage(image, 0.575).subscribe(
        //   async result => {
        //     test = result;
        //   await this.setAttachmentsPayload(result);
        //   // this.uploadAttachment();

        //   },
        //   error => {
        //     console.log(error);
        //     this.fileUploader = false;
        //     this.cdr.detectChanges();
        //   }
        // );
        const reader = new FileReader();
        reader.onload = async () => {
          const imageBase64 = reader.result as string;

          // Compress image (needs full base64 URI)
          this.imageCompress.compressFile(imageBase64, -1, 50, 50)
            .then(async (compressedImage: string) => {
              // ✅ Remove the prefix after compression
              const strippedBase64 = compressedImage.replace(/^data:image\/[a-z]+;base64,/, '');

              await this.setAttachmentsPayload(strippedBase64); // now clean
              this.uploadAttachment();
            })
            .catch((error) => {
              console.log(error);
              this.fileUploader = false;
              this.cdr.detectChanges();
            });
        };
        reader.readAsDataURL(file);

      } else {
        await this.setAttachmentsPayload(image);
      }
      for (const item of e) {
        item.progress = 0;
        this.files.push(item);
      }

      this.uploadFilesSimulator(0);
    } else {
      e = undefined
      file = undefined
      this.fileDropRef.nativeElement.value = null
    }
  }

  private isValidFile(file) {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
    const fileSizeinKB = file.size / 1024;

    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      // this.toastr.warning('Error in uploading ' + file.name + ' due to invalid file type.');
      file=[];
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      // this.msgPopup('Error', 'Error in uploading ' + file.name + ' due to invalid file type.','alert-error-popup')
      return false;
    } else if (!file.name.match()) {
      this.isImageAlert = true;
      file=[];
      this._snackBar.open('Invalid File Name', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      // this.toastr.warning('Invalid File Name');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      // this.msgPopup('Error', 'Invalid File Name','alert-error-popup')
      return false;
    } 
    else if (fileSizeinKB > this.maxSize) {
      file=[];
      this.isImageAlert = true
      this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      // this.toastr.warning(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      // this.msgPopup('Error', file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.','alert-error-popup')
      return false;
    }
    return true;
  }

  // private async setAttachmentsPayload(file) {
  //   this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  // }
  private async setAttachmentsPayload(base64: string) {
		this.attachmentBase64 = base64;
	}

  private uploadAttachment() {    
    this.loader=true;
    this.loaderService.setValue(this.loader)
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    let found = this.dropdownValues.documentType.find(element => {
      return element.value == this.uploadDocumentsDetail.value.documentType;
    });
    let payload = {
      data: {
          applicationId: JSON.parse(decrypt(localStorage.getItem('loginDetails'))) ? JSON.parse(decrypt(localStorage.getItem('loginDetails'))).id :this.profileId,
          addedBy: decrypt(localStorage.getItem('name')),
          content: this.selectedFilePayload,
          processAcronym: 'DAS',
          category: this.documentCategory,
          title: found.label.toString(),
          description: found.label.toString(),
          comments: this.uploadDocumentsDetail.value.comments
      }
    }
    this.uploadService.uploadDocument(payload)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.loader=false;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
            this.uploadUpdatedData.emit({reqPayload:payload,resPayload:res.data,
              documentCategory:this.documentCategory,selectedOption:found})
            this.cdr.detectChanges();
          }
          else{
            // this.ale
          }
        },
        (err) => {
          console.log(err)
        }
      )
  }

  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          console.log(error)
          resolve(null);
        })
    })
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public uploadDocuments(){
    this.markFormsTouched(this.uploadDocumentsDetail)
    if (this.validate(this.uploadDocumentsDetail) && this.attachmentBase64 != undefined) {
      this.uploadAttachment();      
    }
  }

    
  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }

  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }

  public getDocumentSelection(event){
    for(let i=0; i < this.degreeDetailsDocumentList.length;i++){
      for(let j=0; j < this.degreeDetailsDocumentList[i].docList.length;j++){
        if(this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == event) {
          this.eduDropdownLevel.qualificationLevel.push({label: this.degreeDetailsDocumentList[i].degreeName,value:i})
          this.eduDropdownLevel.programTitle.push({label: this.degreeDetailsDocumentList[i].subjectName,value:i})
          // this.dropdownValues.qualificationLevel[i].label=this.degreeDetailsDocumentList[i].degreeName
          // this.dropdownValues.qualificationLevel[i].valuei
        }         
    }      
    }
    this.eduDropdownLevel.qualificationLevel= this.removeDup(this.eduDropdownLevel.qualificationLevel)
    this.eduDropdownLevel.programTitle= this.removeDup(this.eduDropdownLevel.programTitle)
  }

  public cancelUpload(){
    this.uploadUpdatedData.emit('cancel')
  }

  public removeDup(array){
    const uniqueArray = array.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index ===  array.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });
    return uniqueArray;
  }

}
